import Header from "./components/Header";
import Footer from "./components/Footer";
import {Outlet, useLocation} from "react-router-dom";
import {useEffect} from "react";
import ReactGA from "react-ga4";
import CookieConsent from "react-cookie-consent";
import {useScrollToTop} from "./components/ScrollToTop.jsx";
import {useAnalytics} from "./utils/analyticsContext";
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PopupForm from "./components/PopupForm";

const App = () => {
    const location = useLocation();
    const {initialized, initializeAnalytics} = useAnalytics();

    useEffect(() => {
        if (initialized) {
            ReactGA.send({
                hitType: "pageview",
                page: location.pathname + location.search,
            });
        }
    }, [location, initialized]);

    const handleAcceptCookies = () => {
        initializeAnalytics();
    };

    const handleRejectCookies = () => {
        console.log("Cookies rejected");
    };

    const cookieConsentStyle = {
        background: "#fff",
        color: "#000",
        marginLeft: "20px",
        marginBottom: "20px",
        borderRadius: "10px",
        boxShadow: "0 0 5px rgba(0,0,0,0.2)",
        width: "650px",
        zIndex: "1000",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
    };

    const cookieConsentMobileStyle = {
        ...cookieConsentStyle,
        width: "90%",
        marginLeft: "5%",
        marginRight: "5%",
    };

    useScrollToTop();
    return (
        <>
            <Header/>
            <Outlet/>
            <Footer/>
            <ToastContainer position="bottom-right"/>
            <PopupForm/>
            <CookieConsent
                location="bottom"
                buttonText="Accept"
                cookieName="cookieConsent"
                style={window.innerWidth < 768 ? cookieConsentMobileStyle : cookieConsentStyle}
                buttonStyle={{fontSize: "15px"}}
                expires={150}
                onAccept={handleAcceptCookies}
                enableDeclineButton
                declineButtonText="Reject"
                onDecline={handleRejectCookies}
                declineButtonStyle={{
                    fontSize: "15px",
                    background: "#b4b4b4",
                    color: "#fff",
                }}
            >
                This website uses cookies to enhance the user experience.
            </CookieConsent>
        </>
    );
};

export default App;
